{
  "version": 1,
  "asset_id": "f994f47b-5e54-46c9-863b-9b4ae45e4d09",
  "project_id": "ce9c7bc3-4703-4722-9a23-513bcb210c19",
  "url": "/__l5e/assets-v1/f994f47b-5e54-46c9-863b-9b4ae45e4d09/nuego.webp",
  "r2_key": "a/v1/ce9c7bc3-4703-4722-9a23-513bcb210c19/f994f47b-5e54-46c9-863b-9b4ae45e4d09/nuego.webp",
  "original_filename": "nuego.webp",
  "size": 9092,
  "content_type": "image/webp",
  "created_at": "2026-07-17T21:18:06Z"
}
